import "core-js/stable";
import "regenerator-runtime/runtime";

import './util/_polyfill.js';
import smoothscroll from 'smoothscroll-polyfill';
import objectFitImages from 'object-fit-images';
import MicroModal from 'micromodal';

smoothscroll.polyfill();
objectFitImages();
MicroModal.init();

import './_slider';
import './_add-index';
import './_global-nav';
